import React, {useCallback, useState} from "react";
import {ConfigProvider} from "antd";
import {StringBuilder} from "../../AppUtils.js";
import {OrderStatusView} from "../../event/OrderStatusView/OrderStatusView.jsx";
import {getOrderContactInfo} from "../../event/utils.jsx";
import "./delivery-info-page.css";
import {DeliveryProviderDeliveryStatus} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts.jsx";
import {GoogleMapAddressNavigator} from "../../components";
import {InputWithSave} from "../../event/EventOrderV2.jsx";
import "./delivery-info-page.css";
import {ContactInfoTag, SectionInfo} from "./utils.jsx";
import {NOOP} from "../../utils/NOOP.jsx";
import moment from "moment";
import {ActivityLocationTypes} from "../../consts.js";
import {isSingleHomeDelivery} from "../../admin/AdminOrders/utils.jsx";

export const DestinationDeliverySection = ({
    deliveryInfo = {},
    onDeliveryStatusChange = NOOP,
    showHeader = true,
    openAddressInNewTab = true
}) => {
    return (
        <ConfigProvider direction="rtl">
            <OrderStatusView
                className="delivery-info-destination-container"
                title={
                    showHeader ? (
                        <div style={{display: "flex", columnGap: "5px", justifyContent: "space-between"}}>
                            <span>מסירה</span>

                            {!!deliveryInfo?.order?.until ? (
                                <div className="delivery-time-label">
                                    <span>{moment(deliveryInfo?.order?.until)?.format("HH:mm")}</span>
                                    <span>-</span>
                                    <span>{moment(deliveryInfo?.order?.dtstart)?.format("HH:mm")}</span>
                                </div>
                            ) : (
                                <span className="delivery-time-label">
                                    {moment(deliveryInfo?.order?.dtstart)?.format("HH:mm")}
                                </span>
                            )}
                        </div>
                    ) : null
                }
                description={[
                    <SectionInfo key="address" title="שם חברה:" value={deliveryInfo?.delivery?.companyName} />,
                    <SectionInfo
                        key="address"
                        title="כתובת:"
                        value={
                            openAddressInNewTab ? (
                                <span className="address-wrapper">
                                    <GoogleMapAddressNavigator
                                        key="destinationAddress"
                                        address={deliveryInfo?.delivery?.destinationAddress?.address}
                                        title={deliveryInfo?.delivery?.destinationAddress?.address}
                                    />
                                </span>
                            ) : (
                                <span>{deliveryInfo?.delivery?.destinationAddress?.address}</span>
                            )
                        }
                    />,
                    <>
                        <SectionInfo
                            className="contact-section-info"
                            title="פרטי הלקוח:"
                            key="contact-info"
                            value={
                                <>
                                    {isSingleHomeDelivery(deliveryInfo?.order) ? (
                                        <span>
                                            {deliveryInfo?.order?.employeesDeliveryDetail?.[0]?.name}&nbsp;
                                            <a
                                                key="tel"
                                                href={`tel:${deliveryInfo?.order?.employeesDeliveryDetail?.[0]?.phone}`}>
                                                {deliveryInfo?.order?.employeesDeliveryDetail?.[0]?.phone}
                                            </a>
                                        </span>
                                    ) : null}
                                    <span className="contact-info-container">
                                        {getOrderContactInfo(deliveryInfo?.order ?? {})?.map(({name, phone}, index) => {
                                            return (
                                                <span key={index}>
                                                    {name}&nbsp;
                                                    <a key="tel" href={`tel:${phone}`}>
                                                        {phone}
                                                    </a>
                                                </span>
                                            );
                                        })}
                                    </span>
                                </>
                            }
                        />
                    </>,
                    ...(deliveryInfo?.order?.deliveryRequests
                        ? [
                              <SectionInfo
                                  key="deliveryRequests"
                                  title="הערות לשליח:"
                                  value={
                                      <span>
                                          {new StringBuilder().append(deliveryInfo?.order?.deliveryRequests).toString()}
                                      </span>
                                  }
                              />
                          ]
                        : [])
                ]}
            />
        </ConfigProvider>
    );
};
